import { jsx } from '@emotion/react';
import { labelStyles, withModifier } from '@zapier/style-encapsulation';

const Styles = labelStyles("ContentSection", {
  root: (size) => [
    {
      maxWidth: 1280,
      margin: "0 auto"
    },
    withModifier(size, {
      small: { padding: "0 var(--zds-space-12)" },
      medium: { padding: "0 var(--zds-space-20)" },
      large: { padding: "0 var(--zds-space-40)" }
    }[size])
  ]
});
const ContentSection = ({ children, size = "small" }) => jsx("div", { css: Styles.root(size), "data-zds": true }, children);

export { ContentSection };
//# sourceMappingURL=ContentSection.es.js.map
